/** What a page shows before its entity exists. Says what is missing and how it
 * gets created — an empty page that explains nothing is a dead end. */
export function EmptyState({ title, hint }: { title: string; hint: string }) {
  return (
    <div className="console-empty">
      <p className="empty-title">{title}</p>
      <p className="empty-hint">{hint}</p>
    </div>
  );
}

/** A page's section heading, with the count of what it holds. */
export function SectionHead({ title, count }: { title: string; count?: number }) {
  return (
    <div className="section-head">
      <h2>{title}</h2>
      {count !== undefined && <span className="section-count">{count}</span>}
    </div>
  );
}
